// extracted by mini-css-extract-plugin
module.exports = {"c":"c___VB9no","leftC":"leftC___c9Tyl","rightC":"rightC___so0V0","is-mobile":"is-mobile___Q_vhd"};